/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { Canvas } from '../components/Canvas';
import { InsightGraph } from './components/InsightGraph';
import { defaultMargins } from '../utils';
import { useCharts } from '../components/Charts';
import { scaleTime } from '@visx/scale';
export function InsightTimeline(_a) {
    var durations = _a.durations, xDomain = _a.xDomain, marginProps = _a.margins, _b = _a.height, height = _b === void 0 ? 24 : _b, _c = _a.barHeight, barHeight = _c === void 0 ? 16 : _c, _d = _a.hideRightGradient, hideRightGradient = _d === void 0 ? false : _d;
    var width = useCharts().width;
    var margins = defaultMargins(marginProps);
    var boundedWidth = width - margins.left - margins.right;
    var xScale = scaleTime().domain(xDomain).range([0, boundedWidth]);
    return (React.createElement(Canvas, { height: height, margins: margins },
        React.createElement(InsightGraph, { durations: durations, xScale: xScale, barHeight: barHeight, hideRightGradient: hideRightGradient })));
}
//# sourceMappingURL=InsightTimeline.js.map